/**
 * Permisos de edición de vacantes ATS (solo para UX).
 *
 * Refleja la lógica del backend (Positions.canUserEditPosition). La seguridad
 * real la impone el backend; esto solo sirve para mostrar/ocultar controles y
 * evitar que un usuario sin permiso entre a la pantalla de edición.
 *
 * Reglas:
 * - Admins (admin / admin-grafton / super-admin) siempre pueden.
 * - Un "user" normal puede si la creó (createdBy / lastUpdatedBy legacy)
 *   o si un admin lo agregó a usuariosAsignados.
 */
export const isAdminUser = (user) =>
  ['admin', 'admin-grafton', 'super-admin'].includes(user?.rol);

export const canEditPosition = (position, user) => {
  if (!position) return false;
  if (isAdminUser(user)) return true;

  const uid = user?.uid;
  if (!uid) return false;

  const assigned = Array.isArray(position.usuariosAsignados)
    ? position.usuariosAsignados
    : [];

  return (
    position.createdBy === uid ||
    position.lastUpdatedBy === uid ||
    assigned.includes(uid)
  );
};
